/**
 * Gets the user's current timezone from the browser
 * @returns IANA timezone string (e.g., "America/New_York", "America/Chicago")
 */
export const getUserTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    // Fallback to CST (Central Time) if timezone detection fails
    return 'America/Chicago';
  }
};

/**
 * Gets the timezone offset in minutes
 * @returns Offset in minutes (e.g., -300 for EST which is UTC-5)
 */
export const getTimezoneOffset = (): number => new Date().getTimezoneOffset();
